<div class="main-content bg-white">
	<div class="top-bar p-2">
		<div class="row m-0 p-0">
			<h2 class="page-title">Sticker Feed Panel</h2>
			<div class="d-flex">
				<button mat-stroked-button color="primary" (click)="addclient()">Add client</button>
				<button mat-stroked-button color="primary" (click)="run()">Generate & Send Feeds</button>
				<button mat-stoked-button class="btn-danger" (click)="deactiveall()">Deactivate all Clients</button>
			</div>
		</div>
		
	</div>
	

	<ng-container>
		<div class="card-backdrop" *ngIf="anyExpanded" (click)="closeExpanded()"></div>

		<div class="panel">
			<div class="card-container">
				<div *ngFor="let c of clients" [ngClass]="{'d-none': c.id === 'new' && !c.focused}">
			
				<div class="vendor-card-placeholder" *ngIf="c.focused">
					<h4 class="placeholder-header">{{c.vendor_label}}</h4>
					<svg class="placeholder-icon" width="32" height="32" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" [innerHTML]="viewing_icon"></svg>
				</div>

				<mat-card class="vendor-card mat-elevation-z2"
					[class.is-focused]="c.focused"
					[class.is-closing]="c.closing"
					[class.is-dimmed]="anyExpanded && !c.focused"
					[class.is-inactive]="c.status == 'red'">
				<mat-card-header [class.vendor-card-header-expanded]="c.focused" class="vendor-card-header">
					<mat-card-title>
						<div class="row justify-content-between client-label">
							<h4>
								<p *ngIf="c.focused && c.adding" class="font-weight-lighter">New Client set up &nbsp;</p>
								{{c.vendor_label}} <span *ngIf="c.focused"> - Client settings</span>
							</h4>
							<span class="status-container">
								<strong class="status-label" *ngIf="c?.status == 'red' || c?.connection"> 
									<ng-container *ngIf="!c.connection">missing credentials</ng-container>
									<ng-container *ngIf="c.connection">{{c.connection.message}}</ng-container>
								</strong>
								<span class="status-dot" [ngClass]="'status-' + c.status" [title]="c.status"></span>
							</span>
						</div>
					</mat-card-title>
				</mat-card-header>

				<mat-card-content class="mat-card-body" [class.no-scroll]="!c.focused">
					<ng-container *ngIf="!c.focused" @fade>
						<div class="client-summary">
							<div class="credentials-summary">
								<ng-container *ngIf="c.connection_type !== 'api'">
									<div class="summary-row">
										<span class="summary-label">User</span>
										<span class="summary-value">{{c.username ? c.username : 'Missing'}}</span>
									</div>
									<div class="summary-row">
										<span class="summary-label">Password</span>
										<i class="material-icons summary-status-icon" [ngClass]="c.password_set ? 'is-set' : 'is-missing'" [title]="c.password_set ? 'Set' : 'Missing'">
											{{ c.password_set ? 'check_circle' : 'cancel' }}
										</i>
									</div>
									<div class="summary-row">
										<span class="summary-label">Host / Path</span>
										<span class="summary-value" [title]="(c.serverhost || 'Missing') + (c.path ? ' — ' + c.path : '')">
											{{c.serverhost ? c.serverhost : 'Missing'}}<span *ngIf="c.path"> — {{c.path}}</span>
										</span>
									</div>
								</ng-container>
								<ng-container *ngIf="c.connection_type === 'api'">
									<div class="summary-row">
										<span class="summary-label">Auth</span>
										<span class="summary-value">{{ c.auth_type === 'static_bearer' ? 'Static Bearer' : 'OAuth2 Client Credentials' }}</span>
									</div>
									<div class="summary-row">
										<span class="summary-label">Credentials</span>
										<i class="material-icons summary-status-icon"
											[ngClass]="(c.auth_type === 'static_bearer' ? c.access_token_set : (c.client_id && c.client_secret_set)) ? 'is-set' : 'is-missing'"
											[title]="(c.auth_type === 'static_bearer' ? c.access_token_set : (c.client_id && c.client_secret_set)) ? 'Set' : 'Missing'">
											{{ (c.auth_type === 'static_bearer' ? c.access_token_set : (c.client_id && c.client_secret_set)) ? 'check_circle' : 'cancel' }}
										</i>
									</div>
									<div class="summary-row" *ngIf="c.auth_type !== 'static_bearer'">
										<span class="summary-label">Client ID</span>
										<span class="summary-value" [title]="c.client_id || 'Not generated'">{{c.client_id ? c.client_id : 'Not generated'}}</span>
									</div>
								</ng-container>
								<div class="summary-row">
									<span class="summary-label">Last Time/Size</span>
									<span class="summary-value font-weight-lighter">
										{{c.lastsent ? c.lastsent : ''}}<span *ngIf="c.lastfile"> — {{c.lastfile}}</span>
									</span>
								</div>
							</div>
							<div class="exclusions-summary">
								<div class="summary-row">
									<span class="summary-label" [class.copying]="c.copying" (click)="c.copying ? stopcopy(c): copyfrom(c)">
										<mat-icon class="icon-small" *ngIf="!c.copying && !copying">content_copy</mat-icon>
										<ng-container *ngIf="c.copying">COPYING</ng-container>
										
										<ng-container *ngIf="!c.copying && copying">
											<button mat-stroked-button color="primary" class="btn-small copyto-btn" (click)="copyto(c)">Paste Exclusions</button>
										</ng-container>
										
										<ng-container *ngIf="c.copying || !copying">
											Exclusions
										</ng-container>
									</span>
									<span class="summary-value">{{c.excluded_brands.length}} brands, {{c.excluded_stockids.length}} SKUs</span>
								</div>
							</div>
						</div>
					</ng-container>

					<ng-container *ngIf="c.focused && c.viewing == 'settings'" @fade>
						<div class="feed-credentials-row">
							<mat-form-field appearance="outline" *ngIf="c?.adding">
								<mat-label>Vendor Key</mat-label>
								<mat-error *ngIf="key_in_use">Client key already being used</mat-error>
								<input matInput [(ngModel)]="c.vendor_key" autocomplete="off" required (input)="keyCheck($event)">
							</mat-form-field>
							<mat-form-field appearance="outline" *ngIf="c?.adding">
								<mat-label>Vendor Label</mat-label>
								<mat-error *ngIf="label_in_use">Client label already being used</mat-error>
								<input matInput [(ngModel)]="c.vendor_label" autocomplete="off" required (input)="labelCheck($event)">
							</mat-form-field>
							<div class="api-toggle-row">
								<mat-slide-toggle
									[checked]="c.connection_type === 'api'"
									(change)="c.connection_type = $event.checked ? 'api' : 'ftp'">
									API access {{ c.connection_type === 'api' ? '(OAuth/Bearer)' : '(off — using file drop)' }}
								</mat-slide-toggle>
							</div>

							<div class="debtor-section row w-100">
								<mat-form-field appearance="outline" [ngClass]="{'col-6 m-0 p-0': c.connection_type === 'api'}">
									<mat-label>Debtor</mat-label>
									<mat-icon matPrefix>search</mat-icon>
									<input matInput
										[(ngModel)]="debtorSearchTerm[c.vendor_key]"
										(input)="debtorSearch($event.target.value, c)"
										[matAutocomplete]="autoDebtor"
										placeholder="Name or account #..."
										required
										autocomplete="off">
									<mat-autocomplete #autoDebtor="matAutocomplete" (optionSelected)="selectDebtor(c, $event.option.value)">
										<mat-option *ngFor="let opt of debtorSearchResults[c.vendor_key]" [value]="opt">
											<b>{{opt.debtorno}}</b> &mdash; {{opt.name}}
										</mat-option>
									</mat-autocomplete>
									<mat-spinner matSuffix [diameter]="18" *ngIf="debtorSearching[c.vendor_key]"></mat-spinner>
									<mat-error *ngIf="!c.debtorno">Debtor is required</mat-error>
								</mat-form-field>

								<mat-form-field appearance="outline" [ngClass]="{'col-6 m-0 p-0': c.connection_type === 'api'}">
									<mat-label>Branch</mat-label>
									<mat-select [(ngModel)]="c.branchcode" (selectionChange)="onBranchSelected(c, $event.value)" [disabled]="!c.debtorno" required>
										<mat-option [value]="'all'">All</mat-option>
										<mat-option *ngFor="let b of branchOptions[c.vendor_key]" [value]="b.branchcode">{{b.branchcode}} &mdash; {{b.brname}}</mat-option>
										
									</mat-select>
									<mat-error *ngIf="!c.branchcode">Branch is required</mat-error>
								</mat-form-field>
							</div>

							<div class="shipvia-section">
								<mat-form-field appearance="fill" class="shipvia-select-field w-50">
									<mat-label>Allowed Delivery Types</mat-label>
									<mat-select [(ngModel)]="c.allowed_shipvia" multiple [compareWith]="compareShipvia" (selectionChange)="onShipviaChange(c)">
										<mat-option *ngFor="let s of shipviaOptions" [value]="s.shipper_id">{{s.shippername}}</mat-option>
									</mat-select>
								</mat-form-field>

								<div class="shipvia-freight-row" *ngIf="c.allowed_shipvia.length">
									<div class="shipvia-freight-item" *ngFor="let id of c.allowed_shipvia">
										<span class="shipvia-freight-label">{{getShipperName(id)}}</span>
										<mat-form-field appearance="outline" class="shipvia-freight-input">
											<mat-label>Freight</mat-label>
											<span matPrefix>$&nbsp;</span>
											<input matInput type="number" min="0" step="0.01" [(ngModel)]="c.shipvia_freight[id]">
										</mat-form-field>
										<mat-checkbox class="shipvia-label-checkbox" [(ngModel)]="c.shipvia_requires_label[id]">Requires shipping label</mat-checkbox>
									</div>
								</div>
							</div>

							<ng-container *ngIf="c.connection_type !== 'api'">
								<mat-form-field appearance="outline">
									<mat-label>Username</mat-label>
									<input matInput [(ngModel)]="c.username" autocomplete="off">
								</mat-form-field>
								<mat-form-field appearance="outline">
									<mat-label>Server host</mat-label>
									<input matInput [(ngModel)]="c.serverhost" autocomplete="off">
								</mat-form-field>
								<mat-form-field appearance="outline">
									<mat-label>{{ c.password_set ? 'Password (leave blank to keep current)' : 'Password' }}</mat-label>
									<input matInput type="password" [(ngModel)]="c.password" autocomplete="new-password">
								</mat-form-field>
								<mat-form-field appearance="outline">
									<mat-label>Path</mat-label>
									<input matInput [(ngModel)]="c.path" autocomplete="off">
								</mat-form-field>
								<mat-form-field appearance="outline">
									<mat-label>Protocol</mat-label>
									<mat-select [(ngModel)]="c.protocol">
										<mat-option value="SFTP">SFTP</mat-option>
										<mat-option value="FTP">FTP</mat-option>
									</mat-select>
								</mat-form-field>
								<mat-form-field appearance="outline">
									<mat-label>Protocol Type</mat-label>
									<mat-select [(ngModel)]="c.protocol_type">
										<mat-option value="">Default</mat-option>
										<mat-option value="2">2</mat-option>
										<mat-option value="3">3</mat-option>
									</mat-select>
								</mat-form-field>
								<mat-form-field appearance="outline">
									<mat-label>Port</mat-label>
									<input matInput type="number" [(ngModel)]="c.port" autocomplete="off">
								</mat-form-field>
								<mat-form-field appearance="outline">
									<mat-label>Filename</mat-label>
									<input matInput [(ngModel)]="c.filename" autocomplete="off">
								</mat-form-field>
								<div class="credentials-checkbox-row">
									<mat-checkbox [(ngModel)]="c.emailcopy">Email Copy</mat-checkbox>
									<mat-checkbox [(ngModel)]="c.blankstartrow">Blank Start Row</mat-checkbox>
								</div>
							</ng-container>

							<ng-container *ngIf="c.connection_type === 'api'">
								<div class="row m-0 p-0 w-100">
								<div class="api-section m-0 p-0 col-8">
									<div class="row m-0">
										<mat-label>API information</mat-label>
										<p class="api-provider-note">We're the provider here — vendors connect to us using credentials we generate below. Nothing to send; they'll pull their feed on their own schedule.</p>
									</div>

									<span class="api-info-group">
										<div class="row ml-1 mr-1 w-100 jusify-content-between">
											<mat-form-field appearance="outline" class="col-5">
												<mat-label>Auth Type</mat-label>
												<mat-select [(ngModel)]="c.auth_type">
													<mat-option value="oauth2_client_credentials">OAuth2 (Client Credentials)</mat-option>
												</mat-select>
											</mat-form-field>
			
											<ng-container *ngIf="c.auth_type !== 'static_bearer'">
												<mat-form-field appearance="outline" class="col-5">
													<mat-label>Client ID</mat-label>
													<input matInput [ngModel]="c.client_id" disabled placeholder="Not generated yet">
												</mat-form-field>
											</ng-container>
			
			
											<div class="api-endpoints-info ml-3">
												<div class="summary-row" *ngIf="c.auth_type !== 'static_bearer'">
													<span class="summary-label">Token URL</span>
													<span class="summary-value">{{stickerFeedTokenEndpoint}}</span>
												</div>
												<div class="summary-row">
													<span class="summary-label">Feed URL</span>
													<span class="summary-value">{{stickerFeedFeedEndpoint}}</span>
												</div>
											</div>
										</div>
									</span>
									

									<div class="credentials-generate-row">
										<button mat-stroked-button color="primary" (click)="generateCredentials(c)" [disabled]="c.generatingCredentials">
											{{ c.generatingCredentials ? 'Generating...' : ((c.auth_type === 'static_bearer' ? c.access_token_set : c.client_secret_set) ? 'Rotate Credentials' : 'Generate Credentials') }}
										</button>
										<span class="api-rotate-warning" *ngIf="c.auth_type === 'static_bearer' ? c.access_token_set : c.client_secret_set">Rotating invalidates the vendor's current credential immediately.</span>
									</div>

									<div class="api-revealed-credential" *ngIf="c.revealed">
										<p class="api-revealed-title">Copy this now — it won't be shown again:</p>
										<ng-container *ngIf="c.auth_type === 'static_bearer'">
											<code>{{c.revealed.bearer_token}}</code>
										</ng-container>
										<ng-container *ngIf="c.auth_type !== 'static_bearer'">
											<div><strong>Client ID:</strong> <code>{{c.revealed.client_id}}</code></div>
											<div><strong>Client Secret:</strong> <code>{{c.revealed.client_secret}}</code></div>
										</ng-container>
										<button mat-button (click)="dismissRevealedCredentials(c)">Done, I've copied this</button>
									</div>
								</div>

								<div class="flex api-endpoint-controls col-2 m-0 p-2">
									<mat-label class="mb-2">API endpoints allowed</mat-label>
									<div class="m-0 p-0 w-100 row justify-content-between" *ngFor="let endpoint of c.api_endpoints">
										<span class="summary-label">{{endpoint['function']}}</span>
										<span class="summary-value">
											<mat-checkbox [checked]="c.allowed_endpoints.includes(endpoint.function_id)" (change)="toggleEndpoint(c, endpoint.function_id)"></mat-checkbox>
										</span>
									</div>
								</div>

								<div class="col-2 m-0 p-0">
									
								</div>
							</div>

							</ng-container>
							<div class="credentials-save">
								<button mat-stroked-button class="btn-danger" [matTooltip]="'Permanently remove client access and entry'" (click)="removeclient(c)">Delete Client</button>
								<div class="col-1"></div>
								<button mat-stroked-button *ngIf="c.connection_type !== 'api'" [matTooltip]="'One time sending of feed'" (click)="run(c)">Generate & Send Feed?</button>
								<span class="saved-msg" *ngIf="saved[c.vendor_key]">Saved</span>
								<span class="save-error-msg" *ngIf="saveError[c.vendor_key]">{{saveError[c.vendor_key]}}</span>
								<button mat-stroked-button color="primary" (click)="save(c)" [disabled]="saving[c.vendor_key] || c.vendor_key == '' || c.vendor_label == '' || !c.debtorno || !c.branchcode"> {{ saving[c.vendor_key] ? 'Saving...' : 'Save Client' }} </button>
								
							</div>
						</div>

						<div class="exclusions-row">
						<div class="add-brand-row stockid-section exclusion-col" [class.full-width]="c.showBrandEditor">
							<div class="stockid-toolbar">
								<h5 class="stockid-title">Brand Exclusions <span class="stockid-count">({{c.excluded_brands.length}})</span></h5>
								<button type="button" class="brand-bulk-btn" (click)="toggleBrandEditor(c)">
									<i class="material-icons stockid-btn-icon">{{ c.showBrandEditor ? 'close' : 'edit' }}</i> {{ c.showBrandEditor ? 'Close' : 'Edit Brands' }}
								</button>
							</div>

							<ng-container *ngIf="!c.showBrandEditor">
								<div class="stockid-table-wrap" *ngIf="c.excluded_brands.length">
									<table class="table table-hover table-sm stockid-table">
										<colgroup>
											<col class="col-stockid">
											<col class="col-stockdesc">
											<col class="col-stockremove">
										</colgroup>
										<thead>
											<tr>
												<th>Brand</th>
												<th>Mfg Code</th>
												<th></th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let brandName of c.excluded_brands">
												<td>{{brandName}}</td>
												<td class="stockid-desc-col">{{ getBrandMfgCode(brandName) }}</td>
												<td class="stockid-remove-col">
													<i class="material-icons stockid-remove-icon" (click)="removeBrand(c, brandName)" title="Remove">close</i>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
								<p class="stockid-empty-msg" *ngIf="!c.excluded_brands.length">No brands excluded.</p>
							</ng-container>

							<div class="brand-table-row" *ngIf="c.showBrandEditor">
								<div class="brand-toolbar">
									<div class="brand-search-wrap">
										<i class="material-icons brand-search-icon">search</i>
										<input type="text" class="brand-search-input" placeholder="Filter brands…" [(ngModel)]="c.brandFilter" autocomplete="off">
									</div>
									<div class="brand-bulk-actions">
										<button type="button" class="brand-bulk-btn" (click)="setAllBrands(c, true)">Exclude All</button>
										<button type="button" class="brand-bulk-btn" (click)="setAllBrands(c, false)">Allow All</button>
									</div>
								</div>
								<div class="brand-table-wrap">
									<table class="table table-hover table-sm brand-table">
										<colgroup>
											<col class="col-status">
											<col class="col-brand">
											<col class="col-mfgcode">
										</colgroup>
										<thead>
											<tr>
												<th class="brand-status-col"></th>
												<th>Brand</th>
												<th>Mfg Code</th>
											</tr>
										</thead>
										<tbody>
											<ng-container *ngIf="filterBrands(c) as filtered">
												<tr *ngFor="let b of filtered" class="brand-row"
													[class.is-excluded]="c.excluded_brands.includes(b.name)"
													(click)="toggleBrand(c, b.name)">
													<td class="brand-status-col">
														<i class="material-icons brand-status-icon" [ngClass]="c.excluded_brands.includes(b.name) ? 'is-blocked' : 'is-allowed'">
															{{ c.excluded_brands.includes(b.name) ? 'block' : 'check_circle' }}
														</i>
													</td>
													<td class="brand-name-col" [title]="b.name">{{b.name}}</td>
													<td class="brand-mfgcode-col" [title]="b.mfg_code">{{b.mfg_code}}</td>
												</tr>
												<tr *ngIf="!filtered.length">
													<td colspan="3" class="brand-empty-row">No brands match "{{c.brandFilter}}"</td>
												</tr>
											</ng-container>
										</tbody>
									</table>
								</div>
							</div>
						</div>

						<div class="add-brand-row stockid-section exclusion-col" [class.full-width]="c.showItemPicker">
							<div class="stockid-toolbar">
								<h5 class="stockid-title">Stock ID Exclusions <span class="stockid-count">({{c.excluded_stockids.length}})</span></h5>
								<div class="stockid-actions">
									<button type="button" class="brand-bulk-btn" (click)="toggleItemPicker(c)">
										<i class="material-icons stockid-btn-icon">search</i> {{ c.showItemPicker ? 'Close Search' : 'Search & Add' }}
									</button>
									<button type="button" class="brand-bulk-btn" (click)="stockidFileInput.click()">
										<i class="material-icons stockid-btn-icon">upload_file</i> Upload Excel
									</button>
									<input #stockidFileInput type="file" accept=".xlsx,.xls,.csv" hidden (change)="onStockIdFileSelect($event, c)">
								</div>
							</div>

							<p class="stockid-upload-error" *ngIf="stockidUploadError[c.vendor_key]">{{stockidUploadError[c.vendor_key]}}</p>

							<div class="item-picker-panel" *ngIf="c.showItemPicker">
								<app-item-picker [selectionReverse]="true" [currentItems]="c.excluded_stockids" (saveresults)="updateBlockedSkus(c, $event)"></app-item-picker>
							</div>

							<ng-container *ngIf="!c.showItemPicker">
								<div class="stockid-table-wrap" *ngIf="c.excluded_stockids.length">
									<table class="table table-hover table-sm stockid-table">
										<colgroup>
											<col class="col-stockid">
											<col class="col-stockdesc">
											<col class="col-stockremove">
										</colgroup>
										<thead>
											<tr>
												<th>Stock ID</th>
												<th>Description</th>
												<th></th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let item of c.excluded_stockids">
												<td>{{item.stockid}}</td>
												<td class="stockid-desc-col" [title]="item.description">{{item.description}}</td>
												<td class="stockid-remove-col">
													<i class="material-icons stockid-remove-icon" (click)="removeStockId(c, item.stockid)" title="Remove">close</i>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
								<p class="stockid-empty-msg" *ngIf="!c.excluded_stockids.length">No stock IDs excluded.</p>
							</ng-container>
						</div>
						</div>
					</ng-container>

					<ng-container *ngIf="c.focused && c.viewing == 'analytics'" @fade>
						<div class="logs-toolbar">
							<mat-form-field appearance="outline" class="logs-date-field">
								<mat-label>From</mat-label>
								<input matInput type="date" [(ngModel)]="logsDateFrom[c.vendor_key]">
							</mat-form-field>
							<mat-form-field appearance="outline" class="logs-date-field">
								<mat-label>To</mat-label>
								<input matInput type="date" [(ngModel)]="logsDateTo[c.vendor_key]">
							</mat-form-field>
							<button mat-stroked-button color="primary" (click)="searchLogs(c)" [disabled]="logsLoading[c.vendor_key]">Search</button>
						</div>

						<p class="save-error-msg" *ngIf="logsError[c.vendor_key]">{{logsError[c.vendor_key]}}</p>

						<div class="logs-loading" *ngIf="logsLoading[c.vendor_key]">Loading...</div>

						<ng-container *ngIf="!logsLoading[c.vendor_key]">
							<div class="stockid-table-wrap log-table-wrap" *ngIf="(logs[c.vendor_key] || []).length; else noLogs">
								<table class="table table-hover table-sm stockid-table log-table">
									<thead>
										<tr>
											<th class="col-2">Time</th>
											<th class="col-2">Action</th>
											<th class="text-center col-1">Result</th>
											<th class="text-center col-1">Status</th>
											<th class="col-6">Detail</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let log of logs[c.vendor_key]">
											<td >{{formatLogTimestamp(log.created_at)}}</td>
											<td>{{log.action}}</td>
											<td [ngClass]="{'log-result-success text-center': log.result === 'success', 'text-center log-result-fail': log.result === 'fail'}">
												<div>{{log.result | uppercase}}</div>
											</td>
											<td class="text-center">{{log.http_status}}</td>
											<td  [title]="log.error_detail">{{log.error_detail}}</td>
										</tr>
									</tbody>
								</table>
							</div>
							<ng-template #noLogs>
								<p class="stockid-empty-msg">No log entries found{{ logsDateFrom[c.vendor_key] || logsDateTo[c.vendor_key] ? ' for this date range' : '' }}.</p>
							</ng-template>
						</ng-container>

						<div class="logs-pager" *ngIf="(logsTotal[c.vendor_key] || 0) > 0">
							<button mat-button (click)="logsPrevPage(c)" [disabled]="(logsPage[c.vendor_key] || 1) <= 1 || logsLoading[c.vendor_key]">Previous</button>
							<span class="logs-pager-label">Page {{logsPage[c.vendor_key] || 1}} of {{logsTotalPages(c)}} &nbsp;({{logsTotal[c.vendor_key]}} entries)</span>
							<button mat-button (click)="logsNextPage(c)" [disabled]="(logsPage[c.vendor_key] || 1) >= logsTotalPages(c) || logsLoading[c.vendor_key]">Next</button>
						</div>
					</ng-container>
				</mat-card-content>

				<mat-card-actions class="mat-card-footer">
					<ng-container *ngIf="!c.focused">
						<svg class="card-icon" width="24" height="24" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" [innerHTML]="analytics_icon" (click)="flipClientCard(c, 'analytics')"></svg>
						<svg class="card-icon" width="24" height="24" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" [innerHTML]="settings_icon" (click)="flipClientCard(c, 'settings')"></svg>
					</ng-container>
					<button mat-button *ngIf="c.focused" (click)="closeExpanded()">Close</button>
				</mat-card-actions>
			</mat-card>
		</div>
			</div>
		</div>
	</ng-container>


</div>
